/* eslint-disable no-param-reassign */
/**
 * function to convert hex color to rgba
 * @param hex
 * @param alpha
 * @returns
 */
function HexToRgba(hex: string, alpha: number) {
  // Remove '#' if present
  hex = hex.replace(/^#/, '');

  // Convert 3-digit hex to 6-digit
  if (hex.length === 3) {
    hex = hex
      .split('')
      .map((c) => c + c)
      .join('');
  }

  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export default HexToRgba;
